/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Api
 * API specification
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AccountAccessRedeemInput,
  AccountAccessStatus,
  BackupReminderStatus,
  BoxScanInput,
  BoxScanResult,
  CollectionView,
  CollectionViewInput,
  CollectionViewUpdate,
  DeleteItemParams,
  ErrorEnvelope,
  ForgeNote,
  ForgeNoteAccess,
  ForgeNoteInput,
  ForgeNoteUnlockInput,
  ForgeTransferPackage,
  ForgeTransferPackageV1,
  ForgeTransferResult,
  GetItemMeasurementSuggestionParams,
  HealthStatus,
  Item,
  ItemChildLinkInput,
  ItemChildrenReplaceInput,
  ItemDraft,
  ItemDraftFinalizeInput,
  ItemDraftFinalizeResult,
  ItemDraftPhotoJob,
  ItemDraftPhotoRoleInput,
  ItemDraftStartInput,
  ItemInput,
  ItemMeasurementSuggestionResult,
  ItemOption,
  ItemOptionInput,
  ItemPhotoInput,
  ItemSetInput,
  ItemStats,
  ItemUpdate,
  ListItemsParams,
  Photo,
  PublicForgeNote,
  RequestUploadUrl503,
  SearchItemsParams,
  SearchResult,
  UploadUrlRequest,
  UploadUrlResponse
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * Returns server health status
 * @summary Health check
 */
export const healthCheck = async ( options?: Parameters<typeof customFetch>[1]): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAccountAccessUrl = () => {




  return `/api/account-access`
}

/**
 * @summary Check whether the authenticated account is approved
 */
export const getAccountAccess = async ( options?: Parameters<typeof customFetch>[1]): Promise<AccountAccessStatus> => {

  return customFetch<AccountAccessStatus>(getGetAccountAccessUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAccountAccessQueryKey = () => {
    return [
    `/api/account-access`
    ] as const;
    }


export const getGetAccountAccessQueryOptions = <TData = Awaited<ReturnType<typeof getAccountAccess>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountAccess>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountAccessQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountAccess>>> = ({ signal }) => getAccountAccess({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountAccess>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountAccessQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountAccess>>>
export type GetAccountAccessQueryError = ErrorType<void>


/**
 * @summary Check whether the authenticated account is approved
 */

export function useGetAccountAccess<TData = Awaited<ReturnType<typeof getAccountAccess>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountAccess>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAccountAccessQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRedeemAccountAccessUrl = () => {




  return `/api/account-access/redeem`
}

/**
 * @summary Redeem a one-time invite code
 */
export const redeemAccountAccess = async (accountAccessRedeemInput: AccountAccessRedeemInput, options?: Parameters<typeof customFetch>[1]): Promise<AccountAccessStatus> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<AccountAccessStatus>(getRedeemAccountAccessUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(accountAccessRedeemInput)
  }
);}





export const getRedeemAccountAccessMutationKey = () => ['redeemAccountAccess'] as const;

export const getRedeemAccountAccessMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemAccountAccess>>, TError,RedeemAccountAccessMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof redeemAccountAccess>>, TError,RedeemAccountAccessMutationVariables, TContext> => {

const mutationKey = getRedeemAccountAccessMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof redeemAccountAccess>>, RedeemAccountAccessMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  redeemAccountAccess(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RedeemAccountAccessMutationResult = NonNullable<Awaited<ReturnType<typeof redeemAccountAccess>>>
    export type RedeemAccountAccessMutationBody = BodyType<AccountAccessRedeemInput>
    export type RedeemAccountAccessMutationError = ErrorType<void>
    export type RedeemAccountAccessMutationVariables = {data: BodyType<AccountAccessRedeemInput>}

    /**
 * @summary Redeem a one-time invite code
 */
export const useRedeemAccountAccess = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemAccountAccess>>, TError,RedeemAccountAccessMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof redeemAccountAccess>>,
        TError,
        RedeemAccountAccessMutationVariables,
        TContext
      > => {
      return useMutation(getRedeemAccountAccessMutationOptions(options));
    }

export const getListForgeNotesUrl = () => {




  return `/api/forge-notes`
}

export const listForgeNotes = async ( options?: Parameters<typeof customFetch>[1]): Promise<ForgeNote[]> => {

  return customFetch<ForgeNote[]>(getListForgeNotesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListForgeNotesQueryKey = () => {
    return [
    `/api/forge-notes`
    ] as const;
    }


export const getListForgeNotesQueryOptions = <TData = Awaited<ReturnType<typeof listForgeNotes>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listForgeNotes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListForgeNotesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listForgeNotes>>> = ({ signal }) => listForgeNotes({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listForgeNotes>>, TError, TData> & { queryKey: QueryKey }
}

export type ListForgeNotesQueryResult = NonNullable<Awaited<ReturnType<typeof listForgeNotes>>>
export type ListForgeNotesQueryError = ErrorType<unknown>



export function useListForgeNotes<TData = Awaited<ReturnType<typeof listForgeNotes>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listForgeNotes>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListForgeNotesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateForgeNoteUrl = () => {




  return `/api/forge-notes`
}

export const createForgeNote = async (forgeNoteInput: ForgeNoteInput, options?: Parameters<typeof customFetch>[1]): Promise<ForgeNote> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ForgeNote>(getCreateForgeNoteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(forgeNoteInput)
  }
);}





export const getCreateForgeNoteMutationKey = () => ['createForgeNote'] as const;

export const getCreateForgeNoteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createForgeNote>>, TError,CreateForgeNoteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createForgeNote>>, TError,CreateForgeNoteMutationVariables, TContext> => {

const mutationKey = getCreateForgeNoteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createForgeNote>>, CreateForgeNoteMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createForgeNote(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateForgeNoteMutationResult = NonNullable<Awaited<ReturnType<typeof createForgeNote>>>
    export type CreateForgeNoteMutationBody = BodyType<ForgeNoteInput>
    export type CreateForgeNoteMutationError = ErrorType<unknown>
    export type CreateForgeNoteMutationVariables = {data: BodyType<ForgeNoteInput>}

    export const useCreateForgeNote = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createForgeNote>>, TError,CreateForgeNoteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createForgeNote>>,
        TError,
        CreateForgeNoteMutationVariables,
        TContext
      > => {
      return useMutation(getCreateForgeNoteMutationOptions(options));
    }

export const getExportForgeTransferUrl = (itemId: number,) => {




  return `/api/forge-transfer/export/${itemId}`
}

export const exportForgeTransfer = async (itemId: number, options?: Parameters<typeof customFetch>[1]): Promise<ForgeTransferPackage> => {

  return customFetch<ForgeTransferPackage>(getExportForgeTransferUrl(itemId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportForgeTransferQueryKey = (itemId: number,) => {
    return [
    `/api/forge-transfer/export/${itemId}`
    ] as const;
    }


export const getExportForgeTransferQueryOptions = <TData = Awaited<ReturnType<typeof exportForgeTransfer>>, TError = ErrorType<unknown>>(itemId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportForgeTransfer>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportForgeTransferQueryKey(itemId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportForgeTransfer>>> = ({ signal }) => exportForgeTransfer(itemId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: itemId !== null && itemId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportForgeTransfer>>, TError, TData> & { queryKey: QueryKey }
}

export type ExportForgeTransferQueryResult = NonNullable<Awaited<ReturnType<typeof exportForgeTransfer>>>
export type ExportForgeTransferQueryError = ErrorType<unknown>



export function useExportForgeTransfer<TData = Awaited<ReturnType<typeof exportForgeTransfer>>, TError = ErrorType<unknown>>(
 itemId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportForgeTransfer>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getExportForgeTransferQueryOptions(itemId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getImportForgeTransferUrl = () => {




  return `/api/forge-transfer/import`
}

export const importForgeTransfer = async (forgeTransferPackage: ForgeTransferPackage, options?: Parameters<typeof customFetch>[1]): Promise<ForgeTransferResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ForgeTransferResult>(getImportForgeTransferUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(forgeTransferPackage)
  }
);}





export const getImportForgeTransferMutationKey = () => ['importForgeTransfer'] as const;

export const getImportForgeTransferMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importForgeTransfer>>, TError,ImportForgeTransferMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importForgeTransfer>>, TError,ImportForgeTransferMutationVariables, TContext> => {

const mutationKey = getImportForgeTransferMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importForgeTransfer>>, ImportForgeTransferMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  importForgeTransfer(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportForgeTransferMutationResult = NonNullable<Awaited<ReturnType<typeof importForgeTransfer>>>
    export type ImportForgeTransferMutationBody = BodyType<ForgeTransferPackage>
    export type ImportForgeTransferMutationError = ErrorType<void>
    export type ImportForgeTransferMutationVariables = {data: BodyType<ForgeTransferPackage>}

    export const useImportForgeTransfer = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importForgeTransfer>>, TError,ImportForgeTransferMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof importForgeTransfer>>,
        TError,
        ImportForgeTransferMutationVariables,
        TContext
      > => {
      return useMutation(getImportForgeTransferMutationOptions(options));
    }

export const getGetForgeNoteUrl = (id: number,) => {




  return `/api/forge-notes/${id}`
}

export const getForgeNote = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<ForgeNote> => {

  return customFetch<ForgeNote>(getGetForgeNoteUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetForgeNoteQueryKey = (id: number,) => {
    return [
    `/api/forge-notes/${id}`
    ] as const;
    }


export const getGetForgeNoteQueryOptions = <TData = Awaited<ReturnType<typeof getForgeNote>>, TError = ErrorType<ErrorEnvelope>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getForgeNote>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetForgeNoteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getForgeNote>>> = ({ signal }) => getForgeNote(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getForgeNote>>, TError, TData> & { queryKey: QueryKey }
}

export type GetForgeNoteQueryResult = NonNullable<Awaited<ReturnType<typeof getForgeNote>>>
export type GetForgeNoteQueryError = ErrorType<ErrorEnvelope>



export function useGetForgeNote<TData = Awaited<ReturnType<typeof getForgeNote>>, TError = ErrorType<ErrorEnvelope>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getForgeNote>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetForgeNoteQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateForgeNoteUrl = (id: number,) => {




  return `/api/forge-notes/${id}`
}

export const updateForgeNote = async (id: number,
    forgeNoteInput: ForgeNoteInput, options?: Parameters<typeof customFetch>[1]): Promise<ForgeNote> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ForgeNote>(getUpdateForgeNoteUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(forgeNoteInput)
  }
);}





export const getUpdateForgeNoteMutationKey = () => ['updateForgeNote'] as const;

export const getUpdateForgeNoteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateForgeNote>>, TError,UpdateForgeNoteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateForgeNote>>, TError,UpdateForgeNoteMutationVariables, TContext> => {

const mutationKey = getUpdateForgeNoteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateForgeNote>>, UpdateForgeNoteMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateForgeNote(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateForgeNoteMutationResult = NonNullable<Awaited<ReturnType<typeof updateForgeNote>>>
    export type UpdateForgeNoteMutationBody = BodyType<ForgeNoteInput>
    export type UpdateForgeNoteMutationError = ErrorType<unknown>
    export type UpdateForgeNoteMutationVariables = {id: number;data: BodyType<ForgeNoteInput>}

    export const useUpdateForgeNote = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateForgeNote>>, TError,UpdateForgeNoteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateForgeNote>>,
        TError,
        UpdateForgeNoteMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateForgeNoteMutationOptions(options));
    }

export const getRevokeForgeNoteUrl = (id: number,) => {




  return `/api/forge-notes/${id}`
}

export const revokeForgeNote = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getRevokeForgeNoteUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRevokeForgeNoteMutationKey = () => ['revokeForgeNote'] as const;

export const getRevokeForgeNoteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeForgeNote>>, TError,RevokeForgeNoteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeForgeNote>>, TError,RevokeForgeNoteMutationVariables, TContext> => {

const mutationKey = getRevokeForgeNoteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeForgeNote>>, RevokeForgeNoteMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  revokeForgeNote(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeForgeNoteMutationResult = NonNullable<Awaited<ReturnType<typeof revokeForgeNote>>>

    export type RevokeForgeNoteMutationError = ErrorType<unknown>
    export type RevokeForgeNoteMutationVariables = {id: number}

    export const useRevokeForgeNote = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeForgeNote>>, TError,RevokeForgeNoteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof revokeForgeNote>>,
        TError,
        RevokeForgeNoteMutationVariables,
        TContext
      > => {
      return useMutation(getRevokeForgeNoteMutationOptions(options));
    }

export const getExportForgeNoteTransferUrl = (id: number,) => {




  return `/api/forge-notes/${id}/transfer`
}

export const exportForgeNoteTransfer = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<ForgeTransferPackageV1> => {

  return customFetch<ForgeTransferPackageV1>(getExportForgeNoteTransferUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportForgeNoteTransferQueryKey = (id: number,) => {
    return [
    `/api/forge-notes/${id}/transfer`
    ] as const;
    }


export const getExportForgeNoteTransferQueryOptions = <TData = Awaited<ReturnType<typeof exportForgeNoteTransfer>>, TError = ErrorType<ErrorEnvelope>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportForgeNoteTransfer>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportForgeNoteTransferQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportForgeNoteTransfer>>> = ({ signal }) => exportForgeNoteTransfer(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportForgeNoteTransfer>>, TError, TData> & { queryKey: QueryKey }
}

export type ExportForgeNoteTransferQueryResult = NonNullable<Awaited<ReturnType<typeof exportForgeNoteTransfer>>>
export type ExportForgeNoteTransferQueryError = ErrorType<ErrorEnvelope>



export function useExportForgeNoteTransfer<TData = Awaited<ReturnType<typeof exportForgeNoteTransfer>>, TError = ErrorType<ErrorEnvelope>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportForgeNoteTransfer>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getExportForgeNoteTransferQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPublicForgeNoteUrl = (token: string,) => {




  return `/api/public/forge-notes/${token}`
}

export const getPublicForgeNote = async (token: string, options?: Parameters<typeof customFetch>[1]): Promise<PublicForgeNote> => {

  return customFetch<PublicForgeNote>(getGetPublicForgeNoteUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicForgeNoteQueryKey = (token: string,) => {
    return [
    `/api/public/forge-notes/${token}`
    ] as const;
    }


export const getGetPublicForgeNoteQueryOptions = <TData = Awaited<ReturnType<typeof getPublicForgeNote>>, TError = ErrorType<void>>(token: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicForgeNote>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicForgeNoteQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicForgeNote>>> = ({ signal }) => getPublicForgeNote(token, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: token !== null && token !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicForgeNote>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPublicForgeNoteQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicForgeNote>>>
export type GetPublicForgeNoteQueryError = ErrorType<void>



export function useGetPublicForgeNote<TData = Awaited<ReturnType<typeof getPublicForgeNote>>, TError = ErrorType<void>>(
 token: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicForgeNote>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPublicForgeNoteQueryOptions(token,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUnlockForgeNoteUrl = (token: string,) => {




  return `/api/public/forge-notes/${token}/unlock`
}

export const unlockForgeNote = async (token: string,
    forgeNoteUnlockInput: ForgeNoteUnlockInput, options?: Parameters<typeof customFetch>[1]): Promise<ForgeNoteAccess> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ForgeNoteAccess>(getUnlockForgeNoteUrl(token),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(forgeNoteUnlockInput)
  }
);}





export const getUnlockForgeNoteMutationKey = () => ['unlockForgeNote'] as const;

export const getUnlockForgeNoteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlockForgeNote>>, TError,UnlockForgeNoteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unlockForgeNote>>, TError,UnlockForgeNoteMutationVariables, TContext> => {

const mutationKey = getUnlockForgeNoteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlockForgeNote>>, UnlockForgeNoteMutationVariables> = (props) => {
          const {token,data} = props ?? {};

          return  unlockForgeNote(token,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnlockForgeNoteMutationResult = NonNullable<Awaited<ReturnType<typeof unlockForgeNote>>>
    export type UnlockForgeNoteMutationBody = BodyType<ForgeNoteUnlockInput>
    export type UnlockForgeNoteMutationError = ErrorType<void>
    export type UnlockForgeNoteMutationVariables = {token: string;data: BodyType<ForgeNoteUnlockInput>}

    export const useUnlockForgeNote = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlockForgeNote>>, TError,UnlockForgeNoteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof unlockForgeNote>>,
        TError,
        UnlockForgeNoteMutationVariables,
        TContext
      > => {
      return useMutation(getUnlockForgeNoteMutationOptions(options));
    }

export const getDownloadPublicForgeNoteTransferUrl = (token: string,) => {




  return `/api/public/forge-notes/${token}/transfer`
}

export const downloadPublicForgeNoteTransfer = async (token: string, options?: Parameters<typeof customFetch>[1]): Promise<ForgeTransferPackageV1> => {

  return customFetch<ForgeTransferPackageV1>(getDownloadPublicForgeNoteTransferUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadPublicForgeNoteTransferQueryKey = (token: string,) => {
    return [
    `/api/public/forge-notes/${token}/transfer`
    ] as const;
    }


export const getDownloadPublicForgeNoteTransferQueryOptions = <TData = Awaited<ReturnType<typeof downloadPublicForgeNoteTransfer>>, TError = ErrorType<void>>(token: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadPublicForgeNoteTransfer>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadPublicForgeNoteTransferQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadPublicForgeNoteTransfer>>> = ({ signal }) => downloadPublicForgeNoteTransfer(token, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: token !== null && token !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadPublicForgeNoteTransfer>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadPublicForgeNoteTransferQueryResult = NonNullable<Awaited<ReturnType<typeof downloadPublicForgeNoteTransfer>>>
export type DownloadPublicForgeNoteTransferQueryError = ErrorType<void>



export function useDownloadPublicForgeNoteTransfer<TData = Awaited<ReturnType<typeof downloadPublicForgeNoteTransfer>>, TError = ErrorType<void>>(
 token: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadPublicForgeNoteTransfer>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDownloadPublicForgeNoteTransferQueryOptions(token,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListItemsUrl = (params?: ListItemsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/items?${stringifiedParams}` : `/api/items`
}

/**
 * Returns the authenticated user's items, most recently updated first.
 * When `q` is provided, results are filtered by a quick search across the
 * item name and key attributes.
 * @summary List the current user's items
 */
export const listItems = async (params?: ListItemsParams, options?: Parameters<typeof customFetch>[1]): Promise<Item[]> => {

  return customFetch<Item[]>(getListItemsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListItemsQueryKey = (params?: ListItemsParams,) => {
    return [
    `/api/items`, ...(params ? [params] : [])
    ] as const;
    }


export const getListItemsQueryOptions = <TData = Awaited<ReturnType<typeof listItems>>, TError = ErrorType<unknown>>(params?: ListItemsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListItemsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listItems>>> = ({ signal }) => listItems(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listItems>>, TError, TData> & { queryKey: QueryKey }
}

export type ListItemsQueryResult = NonNullable<Awaited<ReturnType<typeof listItems>>>
export type ListItemsQueryError = ErrorType<unknown>


/**
 * @summary List the current user's items
 */

export function useListItems<TData = Awaited<ReturnType<typeof listItems>>, TError = ErrorType<unknown>>(
 params?: ListItemsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListItemsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateItemUrl = () => {




  return `/api/items`
}

/**
 * Atomically creates the item and attaches every submitted completed upload
 * reservation. The entire commit fails if any attachment is invalid.
 * @summary Commit a new item and its uploaded photos
 */
export const createItem = async (itemInput: ItemInput, options?: Parameters<typeof customFetch>[1]): Promise<Item> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<Item>(getCreateItemUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(itemInput)
  }
);}





export const getCreateItemMutationKey = () => ['createItem'] as const;

export const getCreateItemMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createItem>>, TError,CreateItemMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createItem>>, TError,CreateItemMutationVariables, TContext> => {

const mutationKey = getCreateItemMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createItem>>, CreateItemMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createItem(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateItemMutationResult = NonNullable<Awaited<ReturnType<typeof createItem>>>
    export type CreateItemMutationBody = BodyType<ItemInput>
    export type CreateItemMutationError = ErrorType<ErrorEnvelope>
    export type CreateItemMutationVariables = {data: BodyType<ItemInput>}

    /**
 * @summary Commit a new item and its uploaded photos
 */
export const useCreateItem = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createItem>>, TError,CreateItemMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createItem>>,
        TError,
        CreateItemMutationVariables,
        TContext
      > => {
      return useMutation(getCreateItemMutationOptions(options));
    }

export const getCreateItemSetUrl = () => {




  return `/api/item-sets`
}

/**
 * @summary Atomically create a Set and its blades
 */
export const createItemSet = async (itemSetInput: ItemSetInput, options?: Parameters<typeof customFetch>[1]): Promise<Item> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<Item>(getCreateItemSetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(itemSetInput)
  }
);}





export const getCreateItemSetMutationKey = () => ['createItemSet'] as const;

export const getCreateItemSetMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createItemSet>>, TError,CreateItemSetMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createItemSet>>, TError,CreateItemSetMutationVariables, TContext> => {

const mutationKey = getCreateItemSetMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createItemSet>>, CreateItemSetMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createItemSet(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateItemSetMutationResult = NonNullable<Awaited<ReturnType<typeof createItemSet>>>
    export type CreateItemSetMutationBody = BodyType<ItemSetInput>
    export type CreateItemSetMutationError = ErrorType<ErrorEnvelope>
    export type CreateItemSetMutationVariables = {data: BodyType<ItemSetInput>}

    /**
 * @summary Atomically create a Set and its blades
 */
export const useCreateItemSet = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createItemSet>>, TError,CreateItemSetMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createItemSet>>,
        TError,
        CreateItemSetMutationVariables,
        TContext
      > => {
      return useMutation(getCreateItemSetMutationOptions(options));
    }

export const getGetItemMeasurementSuggestionUrl = (params: GetItemMeasurementSuggestionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/items/measurement-suggestion?${stringifiedParams}` : `/api/items/measurement-suggestion`
}

/**
 * @summary Suggest measurements from an exact same-owner item match
 */
export const getItemMeasurementSuggestion = async (params: GetItemMeasurementSuggestionParams, options?: Parameters<typeof customFetch>[1]): Promise<ItemMeasurementSuggestionResult> => {

  return customFetch<ItemMeasurementSuggestionResult>(getGetItemMeasurementSuggestionUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetItemMeasurementSuggestionQueryKey = (params?: GetItemMeasurementSuggestionParams,) => {
    return [
    `/api/items/measurement-suggestion`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetItemMeasurementSuggestionQueryOptions = <TData = Awaited<ReturnType<typeof getItemMeasurementSuggestion>>, TError = ErrorType<ErrorEnvelope>>(params: GetItemMeasurementSuggestionParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getItemMeasurementSuggestion>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetItemMeasurementSuggestionQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getItemMeasurementSuggestion>>> = ({ signal }) => getItemMeasurementSuggestion(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getItemMeasurementSuggestion>>, TError, TData> & { queryKey: QueryKey }
}

export type GetItemMeasurementSuggestionQueryResult = NonNullable<Awaited<ReturnType<typeof getItemMeasurementSuggestion>>>
export type GetItemMeasurementSuggestionQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary Suggest measurements from an exact same-owner item match
 */

export function useGetItemMeasurementSuggestion<TData = Awaited<ReturnType<typeof getItemMeasurementSuggestion>>, TError = ErrorType<ErrorEnvelope>>(
 params: GetItemMeasurementSuggestionParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getItemMeasurementSuggestion>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetItemMeasurementSuggestionQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getStartItemDraftUrl = () => {




  return `/api/item-drafts`
}

/**
 * Idempotently creates or resumes the current user's private draft for the
 * supplied client key. Drafts are excluded from collection APIs until finalized.
 * @summary Start or resume a private capture draft
 */
export const startItemDraft = async (itemDraftStartInput: ItemDraftStartInput, options?: Parameters<typeof customFetch>[1]): Promise<ItemDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ItemDraft>(getStartItemDraftUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(itemDraftStartInput)
  }
);}





export const getStartItemDraftMutationKey = () => ['startItemDraft'] as const;

export const getStartItemDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startItemDraft>>, TError,StartItemDraftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startItemDraft>>, TError,StartItemDraftMutationVariables, TContext> => {

const mutationKey = getStartItemDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startItemDraft>>, StartItemDraftMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  startItemDraft(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartItemDraftMutationResult = NonNullable<Awaited<ReturnType<typeof startItemDraft>>>
    export type StartItemDraftMutationBody = BodyType<ItemDraftStartInput>
    export type StartItemDraftMutationError = ErrorType<ErrorEnvelope>
    export type StartItemDraftMutationVariables = {data: BodyType<ItemDraftStartInput>}

    /**
 * @summary Start or resume a private capture draft
 */
export const useStartItemDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startItemDraft>>, TError,StartItemDraftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof startItemDraft>>,
        TError,
        StartItemDraftMutationVariables,
        TContext
      > => {
      return useMutation(getStartItemDraftMutationOptions(options));
    }

export const getGetItemDraftUrl = (id: number,) => {




  return `/api/item-drafts/${id}`
}

/**
 * @summary Resume a private capture draft
 */
export const getItemDraft = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<ItemDraft> => {

  return customFetch<ItemDraft>(getGetItemDraftUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetItemDraftQueryKey = (id: number,) => {
    return [
    `/api/item-drafts/${id}`
    ] as const;
    }


export const getGetItemDraftQueryOptions = <TData = Awaited<ReturnType<typeof getItemDraft>>, TError = ErrorType<ErrorEnvelope>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getItemDraft>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetItemDraftQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getItemDraft>>> = ({ signal }) => getItemDraft(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getItemDraft>>, TError, TData> & { queryKey: QueryKey }
}

export type GetItemDraftQueryResult = NonNullable<Awaited<ReturnType<typeof getItemDraft>>>
export type GetItemDraftQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary Resume a private capture draft
 */

export function useGetItemDraft<TData = Awaited<ReturnType<typeof getItemDraft>>, TError = ErrorType<ErrorEnvelope>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getItemDraft>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetItemDraftQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAbandonItemDraftUrl = (id: number,) => {




  return `/api/item-drafts/${id}`
}

/**
 * @summary Abandon a private capture draft
 */
export const abandonItemDraft = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getAbandonItemDraftUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAbandonItemDraftMutationKey = () => ['abandonItemDraft'] as const;

export const getAbandonItemDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof abandonItemDraft>>, TError,AbandonItemDraftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof abandonItemDraft>>, TError,AbandonItemDraftMutationVariables, TContext> => {

const mutationKey = getAbandonItemDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof abandonItemDraft>>, AbandonItemDraftMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  abandonItemDraft(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AbandonItemDraftMutationResult = NonNullable<Awaited<ReturnType<typeof abandonItemDraft>>>

    export type AbandonItemDraftMutationError = ErrorType<ErrorEnvelope>
    export type AbandonItemDraftMutationVariables = {id: number}

    /**
 * @summary Abandon a private capture draft
 */
export const useAbandonItemDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof abandonItemDraft>>, TError,AbandonItemDraftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof abandonItemDraft>>,
        TError,
        AbandonItemDraftMutationVariables,
        TContext
      > => {
      return useMutation(getAbandonItemDraftMutationOptions(options));
    }

export const getFinalizeItemDraftUrl = (id: number,) => {




  return `/api/item-drafts/${id}/finalize`
}

/**
 * Saves item metadata and makes the draft visible immediately. Registered
 * photo jobs may continue attaching after this operation returns.
 * @summary Publish a draft without waiting for unfinished photos
 */
export const finalizeItemDraft = async (id: number,
    itemDraftFinalizeInput: ItemDraftFinalizeInput, options?: Parameters<typeof customFetch>[1]): Promise<ItemDraftFinalizeResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ItemDraftFinalizeResult>(getFinalizeItemDraftUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(itemDraftFinalizeInput)
  }
);}





export const getFinalizeItemDraftMutationKey = () => ['finalizeItemDraft'] as const;

export const getFinalizeItemDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finalizeItemDraft>>, TError,FinalizeItemDraftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof finalizeItemDraft>>, TError,FinalizeItemDraftMutationVariables, TContext> => {

const mutationKey = getFinalizeItemDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof finalizeItemDraft>>, FinalizeItemDraftMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  finalizeItemDraft(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FinalizeItemDraftMutationResult = NonNullable<Awaited<ReturnType<typeof finalizeItemDraft>>>
    export type FinalizeItemDraftMutationBody = BodyType<ItemDraftFinalizeInput>
    export type FinalizeItemDraftMutationError = ErrorType<ErrorEnvelope>
    export type FinalizeItemDraftMutationVariables = {id: number;data: BodyType<ItemDraftFinalizeInput>}

    /**
 * @summary Publish a draft without waiting for unfinished photos
 */
export const useFinalizeItemDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finalizeItemDraft>>, TError,FinalizeItemDraftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof finalizeItemDraft>>,
        TError,
        FinalizeItemDraftMutationVariables,
        TContext
      > => {
      return useMutation(getFinalizeItemDraftMutationOptions(options));
    }

export const getRegisterItemDraftPhotoUrl = (id: number,
    clientPhotoId: string,) => {




  return `/api/item-drafts/${id}/photos/${clientPhotoId}`
}

/**
 * @summary Register an expected draft photo
 */
export const registerItemDraftPhoto = async (id: number,
    clientPhotoId: string,
    itemDraftPhotoRoleInput: ItemDraftPhotoRoleInput, options?: Parameters<typeof customFetch>[1]): Promise<ItemDraftPhotoJob> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ItemDraftPhotoJob>(getRegisterItemDraftPhotoUrl(id,clientPhotoId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(itemDraftPhotoRoleInput)
  }
);}





export const getRegisterItemDraftPhotoMutationKey = () => ['registerItemDraftPhoto'] as const;

export const getRegisterItemDraftPhotoMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerItemDraftPhoto>>, TError,RegisterItemDraftPhotoMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof registerItemDraftPhoto>>, TError,RegisterItemDraftPhotoMutationVariables, TContext> => {

const mutationKey = getRegisterItemDraftPhotoMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerItemDraftPhoto>>, RegisterItemDraftPhotoMutationVariables> = (props) => {
          const {id,clientPhotoId,data} = props ?? {};

          return  registerItemDraftPhoto(id,clientPhotoId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegisterItemDraftPhotoMutationResult = NonNullable<Awaited<ReturnType<typeof registerItemDraftPhoto>>>
    export type RegisterItemDraftPhotoMutationBody = BodyType<ItemDraftPhotoRoleInput>
    export type RegisterItemDraftPhotoMutationError = ErrorType<ErrorEnvelope>
    export type RegisterItemDraftPhotoMutationVariables = {id: number;clientPhotoId: string;data: BodyType<ItemDraftPhotoRoleInput>}

    /**
 * @summary Register an expected draft photo
 */
export const useRegisterItemDraftPhoto = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerItemDraftPhoto>>, TError,RegisterItemDraftPhotoMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof registerItemDraftPhoto>>,
        TError,
        RegisterItemDraftPhotoMutationVariables,
        TContext
      > => {
      return useMutation(getRegisterItemDraftPhotoMutationOptions(options));
    }

export const getRemoveItemDraftPhotoUrl = (id: number,
    clientPhotoId: string,) => {




  return `/api/item-drafts/${id}/photos/${clientPhotoId}`
}

/**
 * Removes the expected-photo job and, if it already attached, removes the attached photo and queues its object for cleanup. This operation is idempotent so an interrupted local cancellation can be retried safely.
 * @summary Cancel and remove a queued draft photo
 */
export const removeItemDraftPhoto = async (id: number,
    clientPhotoId: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getRemoveItemDraftPhotoUrl(id,clientPhotoId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveItemDraftPhotoMutationKey = () => ['removeItemDraftPhoto'] as const;

export const getRemoveItemDraftPhotoMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeItemDraftPhoto>>, TError,RemoveItemDraftPhotoMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeItemDraftPhoto>>, TError,RemoveItemDraftPhotoMutationVariables, TContext> => {

const mutationKey = getRemoveItemDraftPhotoMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeItemDraftPhoto>>, RemoveItemDraftPhotoMutationVariables> = (props) => {
          const {id,clientPhotoId} = props ?? {};

          return  removeItemDraftPhoto(id,clientPhotoId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveItemDraftPhotoMutationResult = NonNullable<Awaited<ReturnType<typeof removeItemDraftPhoto>>>

    export type RemoveItemDraftPhotoMutationError = ErrorType<ErrorEnvelope>
    export type RemoveItemDraftPhotoMutationVariables = {id: number;clientPhotoId: string}

    /**
 * @summary Cancel and remove a queued draft photo
 */
export const useRemoveItemDraftPhoto = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeItemDraftPhoto>>, TError,RemoveItemDraftPhotoMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeItemDraftPhoto>>,
        TError,
        RemoveItemDraftPhotoMutationVariables,
        TContext
      > => {
      return useMutation(getRemoveItemDraftPhotoMutationOptions(options));
    }

export const getAttachItemDraftPhotoUrl = (id: number,
    clientPhotoId: string,) => {




  return `/api/item-drafts/${id}/photos/${clientPhotoId}/attach`
}

/**
 * @summary Idempotently attach a completed queued photo
 */
export const attachItemDraftPhoto = async (id: number,
    clientPhotoId: string,
    itemPhotoInput: ItemPhotoInput, options?: Parameters<typeof customFetch>[1]): Promise<Photo> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<Photo>(getAttachItemDraftPhotoUrl(id,clientPhotoId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(itemPhotoInput)
  }
);}





export const getAttachItemDraftPhotoMutationKey = () => ['attachItemDraftPhoto'] as const;

export const getAttachItemDraftPhotoMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof attachItemDraftPhoto>>, TError,AttachItemDraftPhotoMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof attachItemDraftPhoto>>, TError,AttachItemDraftPhotoMutationVariables, TContext> => {

const mutationKey = getAttachItemDraftPhotoMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof attachItemDraftPhoto>>, AttachItemDraftPhotoMutationVariables> = (props) => {
          const {id,clientPhotoId,data} = props ?? {};

          return  attachItemDraftPhoto(id,clientPhotoId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AttachItemDraftPhotoMutationResult = NonNullable<Awaited<ReturnType<typeof attachItemDraftPhoto>>>
    export type AttachItemDraftPhotoMutationBody = BodyType<ItemPhotoInput>
    export type AttachItemDraftPhotoMutationError = ErrorType<ErrorEnvelope>
    export type AttachItemDraftPhotoMutationVariables = {id: number;clientPhotoId: string;data: BodyType<ItemPhotoInput>}

    /**
 * @summary Idempotently attach a completed queued photo
 */
export const useAttachItemDraftPhoto = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof attachItemDraftPhoto>>, TError,AttachItemDraftPhotoMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof attachItemDraftPhoto>>,
        TError,
        AttachItemDraftPhotoMutationVariables,
        TContext
      > => {
      return useMutation(getAttachItemDraftPhotoMutationOptions(options));
    }

export const getSearchItemsUrl = (params: SearchItemsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/items/search?${stringifiedParams}` : `/api/items/search`
}

/**
 * Searches every text field of the user's items and returns each match
 * along with which field matched and a short snippet.
 * @summary Deep search across all item fields
 */
export const searchItems = async (params: SearchItemsParams, options?: Parameters<typeof customFetch>[1]): Promise<SearchResult[]> => {

  return customFetch<SearchResult[]>(getSearchItemsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchItemsQueryKey = (params?: SearchItemsParams,) => {
    return [
    `/api/items/search`, ...(params ? [params] : [])
    ] as const;
    }


export const getSearchItemsQueryOptions = <TData = Awaited<ReturnType<typeof searchItems>>, TError = ErrorType<unknown>>(params: SearchItemsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchItemsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchItems>>> = ({ signal }) => searchItems(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchItems>>, TError, TData> & { queryKey: QueryKey }
}

export type SearchItemsQueryResult = NonNullable<Awaited<ReturnType<typeof searchItems>>>
export type SearchItemsQueryError = ErrorType<unknown>


/**
 * @summary Deep search across all item fields
 */

export function useSearchItems<TData = Awaited<ReturnType<typeof searchItems>>, TError = ErrorType<unknown>>(
 params: SearchItemsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSearchItemsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListItemOptionsUrl = (kind: 'blade_material' | 'blade_treatment' | 'handle_material' | 'handle_treatment',) => {




  return `/api/item-options/${kind}`
}

/**
 * @summary List built-in and the current user's custom item options
 */
export const listItemOptions = async (kind: 'blade_material' | 'blade_treatment' | 'handle_material' | 'handle_treatment', options?: Parameters<typeof customFetch>[1]): Promise<ItemOption[]> => {

  return customFetch<ItemOption[]>(getListItemOptionsUrl(kind),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListItemOptionsQueryKey = (kind: 'blade_material' | 'blade_treatment' | 'handle_material' | 'handle_treatment',) => {
    return [
    `/api/item-options/${kind}`
    ] as const;
    }


export const getListItemOptionsQueryOptions = <TData = Awaited<ReturnType<typeof listItemOptions>>, TError = ErrorType<unknown>>(kind: 'blade_material' | 'blade_treatment' | 'handle_material' | 'handle_treatment', options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listItemOptions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListItemOptionsQueryKey(kind);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listItemOptions>>> = ({ signal }) => listItemOptions(kind, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listItemOptions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListItemOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof listItemOptions>>>
export type ListItemOptionsQueryError = ErrorType<unknown>


/**
 * @summary List built-in and the current user's custom item options
 */

export function useListItemOptions<TData = Awaited<ReturnType<typeof listItemOptions>>, TError = ErrorType<unknown>>(
 kind: 'blade_material' | 'blade_treatment' | 'handle_material' | 'handle_treatment', options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listItemOptions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListItemOptionsQueryOptions(kind,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateItemOptionUrl = (kind: 'blade_material' | 'blade_treatment' | 'handle_material' | 'handle_treatment',) => {




  return `/api/item-options/${kind}`
}

/**
 * @summary Create a custom item option for the current user
 */
export const createItemOption = async (kind: 'blade_material' | 'blade_treatment' | 'handle_material' | 'handle_treatment',
    itemOptionInput: ItemOptionInput, options?: Parameters<typeof customFetch>[1]): Promise<ItemOption> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ItemOption>(getCreateItemOptionUrl(kind),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(itemOptionInput)
  }
);}





export const getCreateItemOptionMutationKey = () => ['createItemOption'] as const;

export const getCreateItemOptionMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createItemOption>>, TError,CreateItemOptionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createItemOption>>, TError,CreateItemOptionMutationVariables, TContext> => {

const mutationKey = getCreateItemOptionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createItemOption>>, CreateItemOptionMutationVariables> = (props) => {
          const {kind,data} = props ?? {};

          return  createItemOption(kind,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateItemOptionMutationResult = NonNullable<Awaited<ReturnType<typeof createItemOption>>>
    export type CreateItemOptionMutationBody = BodyType<ItemOptionInput>
    export type CreateItemOptionMutationError = ErrorType<ErrorEnvelope>
    export type CreateItemOptionMutationVariables = {kind: 'blade_material' | 'blade_treatment' | 'handle_material' | 'handle_treatment';data: BodyType<ItemOptionInput>}

    /**
 * @summary Create a custom item option for the current user
 */
export const useCreateItemOption = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createItemOption>>, TError,CreateItemOptionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createItemOption>>,
        TError,
        CreateItemOptionMutationVariables,
        TContext
      > => {
      return useMutation(getCreateItemOptionMutationOptions(options));
    }

export const getDeleteItemOptionUrl = (kind: 'blade_material' | 'blade_treatment' | 'handle_material' | 'handle_treatment',) => {




  return `/api/item-options/${kind}`
}

/**
 * @summary Delete a custom item option for the current user
 */
export const deleteItemOption = async (kind: 'blade_material' | 'blade_treatment' | 'handle_material' | 'handle_treatment',
    itemOptionInput: ItemOptionInput, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<void>(getDeleteItemOptionUrl(kind),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(itemOptionInput)
  }
);}





export const getDeleteItemOptionMutationKey = () => ['deleteItemOption'] as const;

export const getDeleteItemOptionMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteItemOption>>, TError,DeleteItemOptionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteItemOption>>, TError,DeleteItemOptionMutationVariables, TContext> => {

const mutationKey = getDeleteItemOptionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteItemOption>>, DeleteItemOptionMutationVariables> = (props) => {
          const {kind,data} = props ?? {};

          return  deleteItemOption(kind,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteItemOptionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteItemOption>>>
    export type DeleteItemOptionMutationBody = BodyType<ItemOptionInput>
    export type DeleteItemOptionMutationError = ErrorType<ErrorEnvelope>
    export type DeleteItemOptionMutationVariables = {kind: 'blade_material' | 'blade_treatment' | 'handle_material' | 'handle_treatment';data: BodyType<ItemOptionInput>}

    /**
 * @summary Delete a custom item option for the current user
 */
export const useDeleteItemOption = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteItemOption>>, TError,DeleteItemOptionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteItemOption>>,
        TError,
        DeleteItemOptionMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteItemOptionMutationOptions(options));
    }

export const getGetItemStatsUrl = () => {




  return `/api/items/stats`
}

/**
 * Aggregate counts and value across the user's collection.
 * @summary Collection summary statistics
 */
export const getItemStats = async ( options?: Parameters<typeof customFetch>[1]): Promise<ItemStats> => {

  return customFetch<ItemStats>(getGetItemStatsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetItemStatsQueryKey = () => {
    return [
    `/api/items/stats`
    ] as const;
    }


export const getGetItemStatsQueryOptions = <TData = Awaited<ReturnType<typeof getItemStats>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getItemStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetItemStatsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getItemStats>>> = ({ signal }) => getItemStats({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getItemStats>>, TError, TData> & { queryKey: QueryKey }
}

export type GetItemStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getItemStats>>>
export type GetItemStatsQueryError = ErrorType<unknown>


/**
 * @summary Collection summary statistics
 */

export function useGetItemStats<TData = Awaited<ReturnType<typeof getItemStats>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getItemStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetItemStatsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListCollectionViewsUrl = () => {




  return `/api/collection-views`
}

/**
 * @summary List the current user's saved collection views
 */
export const listCollectionViews = async ( options?: Parameters<typeof customFetch>[1]): Promise<CollectionView[]> => {

  return customFetch<CollectionView[]>(getListCollectionViewsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCollectionViewsQueryKey = () => {
    return [
    `/api/collection-views`
    ] as const;
    }


export const getListCollectionViewsQueryOptions = <TData = Awaited<ReturnType<typeof listCollectionViews>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCollectionViews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCollectionViewsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCollectionViews>>> = ({ signal }) => listCollectionViews({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCollectionViews>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCollectionViewsQueryResult = NonNullable<Awaited<ReturnType<typeof listCollectionViews>>>
export type ListCollectionViewsQueryError = ErrorType<unknown>


/**
 * @summary List the current user's saved collection views
 */

export function useListCollectionViews<TData = Awaited<ReturnType<typeof listCollectionViews>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCollectionViews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCollectionViewsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCollectionViewUrl = () => {




  return `/api/collection-views`
}

/**
 * @summary Save the current collection criteria as a named view
 */
export const createCollectionView = async (collectionViewInput: CollectionViewInput, options?: Parameters<typeof customFetch>[1]): Promise<CollectionView> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<CollectionView>(getCreateCollectionViewUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(collectionViewInput)
  }
);}





export const getCreateCollectionViewMutationKey = () => ['createCollectionView'] as const;

export const getCreateCollectionViewMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCollectionView>>, TError,CreateCollectionViewMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCollectionView>>, TError,CreateCollectionViewMutationVariables, TContext> => {

const mutationKey = getCreateCollectionViewMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCollectionView>>, CreateCollectionViewMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createCollectionView(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCollectionViewMutationResult = NonNullable<Awaited<ReturnType<typeof createCollectionView>>>
    export type CreateCollectionViewMutationBody = BodyType<CollectionViewInput>
    export type CreateCollectionViewMutationError = ErrorType<ErrorEnvelope>
    export type CreateCollectionViewMutationVariables = {data: BodyType<CollectionViewInput>}

    /**
 * @summary Save the current collection criteria as a named view
 */
export const useCreateCollectionView = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCollectionView>>, TError,CreateCollectionViewMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCollectionView>>,
        TError,
        CreateCollectionViewMutationVariables,
        TContext
      > => {
      return useMutation(getCreateCollectionViewMutationOptions(options));
    }

export const getUpdateCollectionViewUrl = (id: number,) => {




  return `/api/collection-views/${id}`
}

/**
 * @summary Rename a saved collection view
 */
export const updateCollectionView = async (id: number,
    collectionViewUpdate: CollectionViewUpdate, options?: Parameters<typeof customFetch>[1]): Promise<CollectionView> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<CollectionView>(getUpdateCollectionViewUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(collectionViewUpdate)
  }
);}





export const getUpdateCollectionViewMutationKey = () => ['updateCollectionView'] as const;

export const getUpdateCollectionViewMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCollectionView>>, TError,UpdateCollectionViewMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCollectionView>>, TError,UpdateCollectionViewMutationVariables, TContext> => {

const mutationKey = getUpdateCollectionViewMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCollectionView>>, UpdateCollectionViewMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateCollectionView(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCollectionViewMutationResult = NonNullable<Awaited<ReturnType<typeof updateCollectionView>>>
    export type UpdateCollectionViewMutationBody = BodyType<CollectionViewUpdate>
    export type UpdateCollectionViewMutationError = ErrorType<ErrorEnvelope>
    export type UpdateCollectionViewMutationVariables = {id: number;data: BodyType<CollectionViewUpdate>}

    /**
 * @summary Rename a saved collection view
 */
export const useUpdateCollectionView = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCollectionView>>, TError,UpdateCollectionViewMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCollectionView>>,
        TError,
        UpdateCollectionViewMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateCollectionViewMutationOptions(options));
    }

export const getDeleteCollectionViewUrl = (id: number,) => {




  return `/api/collection-views/${id}`
}

/**
 * @summary Delete a saved collection view
 */
export const deleteCollectionView = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteCollectionViewUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteCollectionViewMutationKey = () => ['deleteCollectionView'] as const;

export const getDeleteCollectionViewMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCollectionView>>, TError,DeleteCollectionViewMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCollectionView>>, TError,DeleteCollectionViewMutationVariables, TContext> => {

const mutationKey = getDeleteCollectionViewMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCollectionView>>, DeleteCollectionViewMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteCollectionView(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCollectionViewMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCollectionView>>>

    export type DeleteCollectionViewMutationError = ErrorType<ErrorEnvelope>
    export type DeleteCollectionViewMutationVariables = {id: number}

    /**
 * @summary Delete a saved collection view
 */
export const useDeleteCollectionView = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCollectionView>>, TError,DeleteCollectionViewMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCollectionView>>,
        TError,
        DeleteCollectionViewMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteCollectionViewMutationOptions(options));
    }

export const getGetItemUrl = (id: number,) => {




  return `/api/items/${id}`
}

/**
 * @summary Get a single item
 */
export const getItem = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<Item> => {

  return customFetch<Item>(getGetItemUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetItemQueryKey = (id: number,) => {
    return [
    `/api/items/${id}`
    ] as const;
    }


export const getGetItemQueryOptions = <TData = Awaited<ReturnType<typeof getItem>>, TError = ErrorType<ErrorEnvelope>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getItem>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetItemQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getItem>>> = ({ signal }) => getItem(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getItem>>, TError, TData> & { queryKey: QueryKey }
}

export type GetItemQueryResult = NonNullable<Awaited<ReturnType<typeof getItem>>>
export type GetItemQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary Get a single item
 */

export function useGetItem<TData = Awaited<ReturnType<typeof getItem>>, TError = ErrorType<ErrorEnvelope>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getItem>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetItemQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateItemUrl = (id: number,) => {




  return `/api/items/${id}`
}

/**
 * Atomically updates item fields and attaches every submitted completed
 * upload reservation. Existing photos are retained. The entire commit fails
 * if any attachment is invalid.
 * @summary Commit item edits and uploaded photos
 */
export const updateItem = async (id: number,
    itemUpdate: ItemUpdate, options?: Parameters<typeof customFetch>[1]): Promise<Item> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<Item>(getUpdateItemUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(itemUpdate)
  }
);}





export const getUpdateItemMutationKey = () => ['updateItem'] as const;

export const getUpdateItemMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateItem>>, TError,UpdateItemMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateItem>>, TError,UpdateItemMutationVariables, TContext> => {

const mutationKey = getUpdateItemMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateItem>>, UpdateItemMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateItem(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateItem>>>
    export type UpdateItemMutationBody = BodyType<ItemUpdate>
    export type UpdateItemMutationError = ErrorType<ErrorEnvelope>
    export type UpdateItemMutationVariables = {id: number;data: BodyType<ItemUpdate>}

    /**
 * @summary Commit item edits and uploaded photos
 */
export const useUpdateItem = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateItem>>, TError,UpdateItemMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateItem>>,
        TError,
        UpdateItemMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateItemMutationOptions(options));
    }

export const getDeleteItemUrl = (id: number,
    params?: DeleteItemParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/items/${id}?${stringifiedParams}` : `/api/items/${id}`
}

/**
 * @summary Delete an item
 */
export const deleteItem = async (id: number,
    params?: DeleteItemParams, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteItemUrl(id,params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteItemMutationKey = () => ['deleteItem'] as const;

export const getDeleteItemMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteItem>>, TError,DeleteItemMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteItem>>, TError,DeleteItemMutationVariables, TContext> => {

const mutationKey = getDeleteItemMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteItem>>, DeleteItemMutationVariables> = (props) => {
          const {id,params} = props ?? {};

          return  deleteItem(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteItemMutationResult = NonNullable<Awaited<ReturnType<typeof deleteItem>>>

    export type DeleteItemMutationError = ErrorType<ErrorEnvelope>
    export type DeleteItemMutationVariables = {id: number;params?: DeleteItemParams}

    /**
 * @summary Delete an item
 */
export const useDeleteItem = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteItem>>, TError,DeleteItemMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteItem>>,
        TError,
        DeleteItemMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteItemMutationOptions(options));
    }

export const getAddItemPhotoUrl = (id: number,) => {




  return `/api/items/${id}/photos`
}

/**
 * Adds a photo (already uploaded to object storage) to the item. An item
 * may have at most 20 photos, subject to per-role limits.
 * @summary Attach a photo to an item
 */
export const addItemPhoto = async (id: number,
    itemPhotoInput: ItemPhotoInput, options?: Parameters<typeof customFetch>[1]): Promise<Photo> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<Photo>(getAddItemPhotoUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(itemPhotoInput)
  }
);}





export const getAddItemPhotoMutationKey = () => ['addItemPhoto'] as const;

export const getAddItemPhotoMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addItemPhoto>>, TError,AddItemPhotoMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addItemPhoto>>, TError,AddItemPhotoMutationVariables, TContext> => {

const mutationKey = getAddItemPhotoMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addItemPhoto>>, AddItemPhotoMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  addItemPhoto(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddItemPhotoMutationResult = NonNullable<Awaited<ReturnType<typeof addItemPhoto>>>
    export type AddItemPhotoMutationBody = BodyType<ItemPhotoInput>
    export type AddItemPhotoMutationError = ErrorType<ErrorEnvelope>
    export type AddItemPhotoMutationVariables = {id: number;data: BodyType<ItemPhotoInput>}

    /**
 * @summary Attach a photo to an item
 */
export const useAddItemPhoto = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addItemPhoto>>, TError,AddItemPhotoMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addItemPhoto>>,
        TError,
        AddItemPhotoMutationVariables,
        TContext
      > => {
      return useMutation(getAddItemPhotoMutationOptions(options));
    }

export const getLinkItemChildUrl = (id: number,) => {




  return `/api/items/${id}/children`
}

export const linkItemChild = async (id: number,
    itemChildLinkInput: ItemChildLinkInput, options?: Parameters<typeof customFetch>[1]): Promise<Item> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<Item>(getLinkItemChildUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(itemChildLinkInput)
  }
);}





export const getLinkItemChildMutationKey = () => ['linkItemChild'] as const;

export const getLinkItemChildMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkItemChild>>, TError,LinkItemChildMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof linkItemChild>>, TError,LinkItemChildMutationVariables, TContext> => {

const mutationKey = getLinkItemChildMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof linkItemChild>>, LinkItemChildMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  linkItemChild(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LinkItemChildMutationResult = NonNullable<Awaited<ReturnType<typeof linkItemChild>>>
    export type LinkItemChildMutationBody = BodyType<ItemChildLinkInput>
    export type LinkItemChildMutationError = ErrorType<unknown>
    export type LinkItemChildMutationVariables = {id: number;data: BodyType<ItemChildLinkInput>}

    export const useLinkItemChild = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkItemChild>>, TError,LinkItemChildMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof linkItemChild>>,
        TError,
        LinkItemChildMutationVariables,
        TContext
      > => {
      return useMutation(getLinkItemChildMutationOptions(options));
    }

export const getReplaceItemChildrenUrl = (id: number,) => {




  return `/api/items/${id}/children`
}

export const replaceItemChildren = async (id: number,
    itemChildrenReplaceInput: ItemChildrenReplaceInput, options?: Parameters<typeof customFetch>[1]): Promise<Item> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<Item>(getReplaceItemChildrenUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(itemChildrenReplaceInput)
  }
);}





export const getReplaceItemChildrenMutationKey = () => ['replaceItemChildren'] as const;

export const getReplaceItemChildrenMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceItemChildren>>, TError,ReplaceItemChildrenMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof replaceItemChildren>>, TError,ReplaceItemChildrenMutationVariables, TContext> => {

const mutationKey = getReplaceItemChildrenMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceItemChildren>>, ReplaceItemChildrenMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  replaceItemChildren(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplaceItemChildrenMutationResult = NonNullable<Awaited<ReturnType<typeof replaceItemChildren>>>
    export type ReplaceItemChildrenMutationBody = BodyType<ItemChildrenReplaceInput>
    export type ReplaceItemChildrenMutationError = ErrorType<unknown>
    export type ReplaceItemChildrenMutationVariables = {id: number;data: BodyType<ItemChildrenReplaceInput>}

    export const useReplaceItemChildren = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceItemChildren>>, TError,ReplaceItemChildrenMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof replaceItemChildren>>,
        TError,
        ReplaceItemChildrenMutationVariables,
        TContext
      > => {
      return useMutation(getReplaceItemChildrenMutationOptions(options));
    }

export const getUnlinkItemChildUrl = (id: number,
    childId: number,) => {




  return `/api/items/${id}/children/${childId}`
}

export const unlinkItemChild = async (id: number,
    childId: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getUnlinkItemChildUrl(id,childId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getUnlinkItemChildMutationKey = () => ['unlinkItemChild'] as const;

export const getUnlinkItemChildMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkItemChild>>, TError,UnlinkItemChildMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unlinkItemChild>>, TError,UnlinkItemChildMutationVariables, TContext> => {

const mutationKey = getUnlinkItemChildMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlinkItemChild>>, UnlinkItemChildMutationVariables> = (props) => {
          const {id,childId} = props ?? {};

          return  unlinkItemChild(id,childId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnlinkItemChildMutationResult = NonNullable<Awaited<ReturnType<typeof unlinkItemChild>>>

    export type UnlinkItemChildMutationError = ErrorType<unknown>
    export type UnlinkItemChildMutationVariables = {id: number;childId: number}

    export const useUnlinkItemChild = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkItemChild>>, TError,UnlinkItemChildMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof unlinkItemChild>>,
        TError,
        UnlinkItemChildMutationVariables,
        TContext
      > => {
      return useMutation(getUnlinkItemChildMutationOptions(options));
    }

export const getDeleteItemPhotoUrl = (id: number,
    photoId: number,) => {




  return `/api/items/${id}/photos/${photoId}`
}

/**
 * @summary Remove a photo from an item
 */
export const deleteItemPhoto = async (id: number,
    photoId: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteItemPhotoUrl(id,photoId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteItemPhotoMutationKey = () => ['deleteItemPhoto'] as const;

export const getDeleteItemPhotoMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteItemPhoto>>, TError,DeleteItemPhotoMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteItemPhoto>>, TError,DeleteItemPhotoMutationVariables, TContext> => {

const mutationKey = getDeleteItemPhotoMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteItemPhoto>>, DeleteItemPhotoMutationVariables> = (props) => {
          const {id,photoId} = props ?? {};

          return  deleteItemPhoto(id,photoId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteItemPhotoMutationResult = NonNullable<Awaited<ReturnType<typeof deleteItemPhoto>>>

    export type DeleteItemPhotoMutationError = ErrorType<ErrorEnvelope>
    export type DeleteItemPhotoMutationVariables = {id: number;photoId: number}

    /**
 * @summary Remove a photo from an item
 */
export const useDeleteItemPhoto = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteItemPhoto>>, TError,DeleteItemPhotoMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteItemPhoto>>,
        TError,
        DeleteItemPhotoMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteItemPhotoMutationOptions(options));
    }

export const getScanBoxUrl = () => {




  return `/api/scan/box`
}

/**
 * Sends a previously uploaded box photo to a vision model and returns
 * suggested item field values plus the raw extracted text. A normal
 * request runs the server-selected Fast profile. A completed Fast result
 * includes an opaque retry token that authorizes one replay-safe Quality
 * follow-up for the same user and image.
 * @summary Extract item details from a box label photo using AI vision
 */
export const scanBox = async (boxScanInput: BoxScanInput, options?: Parameters<typeof customFetch>[1]): Promise<BoxScanResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<BoxScanResult>(getScanBoxUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(boxScanInput)
  }
);}





export const getScanBoxMutationKey = () => ['scanBox'] as const;

export const getScanBoxMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scanBox>>, TError,ScanBoxMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof scanBox>>, TError,ScanBoxMutationVariables, TContext> => {

const mutationKey = getScanBoxMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scanBox>>, ScanBoxMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  scanBox(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScanBoxMutationResult = NonNullable<Awaited<ReturnType<typeof scanBox>>>
    export type ScanBoxMutationBody = BodyType<BoxScanInput>
    export type ScanBoxMutationError = ErrorType<ErrorEnvelope>
    export type ScanBoxMutationVariables = {data: BodyType<BoxScanInput>}

    /**
 * @summary Extract item details from a box label photo using AI vision
 */
export const useScanBox = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scanBox>>, TError,ScanBoxMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof scanBox>>,
        TError,
        ScanBoxMutationVariables,
        TContext
      > => {
      return useMutation(getScanBoxMutationOptions(options));
    }

export const getRequestUploadUrlUrl = () => {




  return `/api/storage/uploads/request-url`
}

/**
 * Returns an authenticated, server-bounded upload URL. The client sends
 * JSON metadata here, then uploads the file to the returned URL.
 * @summary Request a bounded URL for file upload
 */
export const requestUploadUrl = async (uploadUrlRequest: UploadUrlRequest, options?: Parameters<typeof customFetch>[1]): Promise<UploadUrlResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<UploadUrlResponse>(getRequestUploadUrlUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(uploadUrlRequest)
  }
);}





export const getRequestUploadUrlMutationKey = () => ['requestUploadUrl'] as const;

export const getRequestUploadUrlMutationOptions = <TError = ErrorType<ErrorEnvelope | RequestUploadUrl503>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,RequestUploadUrlMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,RequestUploadUrlMutationVariables, TContext> => {

const mutationKey = getRequestUploadUrlMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestUploadUrl>>, RequestUploadUrlMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  requestUploadUrl(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestUploadUrlMutationResult = NonNullable<Awaited<ReturnType<typeof requestUploadUrl>>>
    export type RequestUploadUrlMutationBody = BodyType<UploadUrlRequest>
    export type RequestUploadUrlMutationError = ErrorType<ErrorEnvelope | RequestUploadUrl503>
    export type RequestUploadUrlMutationVariables = {data: BodyType<UploadUrlRequest>}

    /**
 * @summary Request a bounded URL for file upload
 */
export const useRequestUploadUrl = <TError = ErrorType<ErrorEnvelope | RequestUploadUrl503>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,RequestUploadUrlMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestUploadUrl>>,
        TError,
        RequestUploadUrlMutationVariables,
        TContext
      > => {
      return useMutation(getRequestUploadUrlMutationOptions(options));
    }

export const getGetPublicObjectUrl = (filePath: string,) => {




  return `/api/storage/public-objects/${filePath}`
}

/**
 * Unconditionally public — no authentication or ACL checks.
 * Searches PUBLIC_OBJECT_SEARCH_PATHS for the given file path.
 * @summary Serve a public asset from PUBLIC_OBJECT_SEARCH_PATHS
 */
export const getPublicObject = async (filePath: string, options?: Parameters<typeof customFetch>[1]): Promise<Blob> => {

  return customFetch<Blob>(getGetPublicObjectUrl(filePath),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicObjectQueryKey = (filePath: string,) => {
    return [
    `/api/storage/public-objects/${filePath}`
    ] as const;
    }


export const getGetPublicObjectQueryOptions = <TData = Awaited<ReturnType<typeof getPublicObject>>, TError = ErrorType<ErrorEnvelope>>(filePath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicObjectQueryKey(filePath);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicObject>>> = ({ signal }) => getPublicObject(filePath, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: filePath !== null && filePath !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicObject>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPublicObjectQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicObject>>>
export type GetPublicObjectQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary Serve a public asset from PUBLIC_OBJECT_SEARCH_PATHS
 */

export function useGetPublicObject<TData = Awaited<ReturnType<typeof getPublicObject>>, TError = ErrorType<ErrorEnvelope>>(
 filePath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPublicObjectQueryOptions(filePath,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetStorageObjectUrl = (objectPath: string,) => {




  return `/api/storage/objects/${objectPath}`
}

/**
 * Serves object entities uploaded via presigned URLs. These can optionally
 * be protected with authentication or ACL checks based on the use case.
 * @summary Serve an object entity from PRIVATE_OBJECT_DIR
 */
export const getStorageObject = async (objectPath: string, options?: Parameters<typeof customFetch>[1]): Promise<Blob> => {

  return customFetch<Blob>(getGetStorageObjectUrl(objectPath),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStorageObjectQueryKey = (objectPath: string,) => {
    return [
    `/api/storage/objects/${objectPath}`
    ] as const;
    }


export const getGetStorageObjectQueryOptions = <TData = Awaited<ReturnType<typeof getStorageObject>>, TError = ErrorType<ErrorEnvelope>>(objectPath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStorageObjectQueryKey(objectPath);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStorageObject>>> = ({ signal }) => getStorageObject(objectPath, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: objectPath !== null && objectPath !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStorageObjectQueryResult = NonNullable<Awaited<ReturnType<typeof getStorageObject>>>
export type GetStorageObjectQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary Serve an object entity from PRIVATE_OBJECT_DIR
 */

export function useGetStorageObject<TData = Awaited<ReturnType<typeof getStorageObject>>, TError = ErrorType<ErrorEnvelope>>(
 objectPath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStorageObjectQueryOptions(objectPath,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetBackupReminderUrl = () => {




  return `/api/backups/reminder`
}

/**
 * @summary Get the current user's backup reminder status
 */
export const getBackupReminder = async ( options?: Parameters<typeof customFetch>[1]): Promise<BackupReminderStatus> => {

  return customFetch<BackupReminderStatus>(getGetBackupReminderUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBackupReminderQueryKey = () => {
    return [
    `/api/backups/reminder`
    ] as const;
    }


export const getGetBackupReminderQueryOptions = <TData = Awaited<ReturnType<typeof getBackupReminder>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBackupReminder>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBackupReminderQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBackupReminder>>> = ({ signal }) => getBackupReminder({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBackupReminder>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBackupReminderQueryResult = NonNullable<Awaited<ReturnType<typeof getBackupReminder>>>
export type GetBackupReminderQueryError = ErrorType<unknown>


/**
 * @summary Get the current user's backup reminder status
 */

export function useGetBackupReminder<TData = Awaited<ReturnType<typeof getBackupReminder>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBackupReminder>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBackupReminderQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDismissBackupReminderUrl = () => {




  return `/api/backups/reminder`
}

/**
 * @summary Dismiss the current backup reminder cycle
 */
export const dismissBackupReminder = async ( options?: Parameters<typeof customFetch>[1]): Promise<BackupReminderStatus> => {

  return customFetch<BackupReminderStatus>(getDismissBackupReminderUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDismissBackupReminderMutationKey = () => ['dismissBackupReminder'] as const;

export const getDismissBackupReminderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissBackupReminder>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof dismissBackupReminder>>, TError,void, TContext> => {

const mutationKey = getDismissBackupReminderMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dismissBackupReminder>>, void> = () => {


          return  dismissBackupReminder(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DismissBackupReminderMutationResult = NonNullable<Awaited<ReturnType<typeof dismissBackupReminder>>>

    export type DismissBackupReminderMutationError = ErrorType<unknown>


    /**
 * @summary Dismiss the current backup reminder cycle
 */
export const useDismissBackupReminder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissBackupReminder>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof dismissBackupReminder>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDismissBackupReminderMutationOptions(options));
    }

export const getCompleteBackupReminderUrl = () => {




  return `/api/backups/reminder/complete`
}

/**
 * @summary Mark a successfully downloaded backup as complete
 */
export const completeBackupReminder = async ( options?: Parameters<typeof customFetch>[1]): Promise<BackupReminderStatus> => {

  return customFetch<BackupReminderStatus>(getCompleteBackupReminderUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCompleteBackupReminderMutationKey = () => ['completeBackupReminder'] as const;

export const getCompleteBackupReminderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeBackupReminder>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof completeBackupReminder>>, TError,void, TContext> => {

const mutationKey = getCompleteBackupReminderMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeBackupReminder>>, void> = () => {


          return  completeBackupReminder(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteBackupReminderMutationResult = NonNullable<Awaited<ReturnType<typeof completeBackupReminder>>>

    export type CompleteBackupReminderMutationError = ErrorType<unknown>


    /**
 * @summary Mark a successfully downloaded backup as complete
 */
export const useCompleteBackupReminder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeBackupReminder>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof completeBackupReminder>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCompleteBackupReminderMutationOptions(options));
    }
